.use-brand-font {
    font-family: $brand-font-family;
    font-size: 24px;

    &--bold {
        font-weight: 700;
    }

    @media (min-width: $screen-md) {
        font-size: 30px;
    }
}

.compliance-links {
    img {
        filter: invert(0.4);
        width: auto;
    }
}

:root {
    --sticky-terms-background: #{$body-bg};
}
